import Results from "./results/index";

export default Results;
